module.exports = __webpack_public_path__ + "img/no.968f118f.png";